module.exports = __webpack_public_path__ + "img/career-b4.1d61c8cd.jpg";